import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import { singularize } from 'ember-inflector';
import { action } from '@ember/object';
import { ModelRegistry } from 'ember-data/model';
import DS from 'ember-data';
import DataIndexListController from 'cio/pods/data-index/type/list/controller';
import DataIndexListIndexController from 'cio/pods/data-index/type/list/index/controller';
import AttributeModel from 'cio/models/attribute';
import EventModel from 'cio/models/event';
import Transition from '@ember/routing/-private/transition';

export default class IndexRoute extends Route {
  @service store!: DS.Store;

  queryParams = {
    search: {
      replace: true,
      refreshModel: true,
    },

    page: {
      refreshModel: true,
    },
  };

  model(params: Record<string, any>) {
    let { type } = this.paramsFor('data-index.type') as Record<string, any>;
    return this.store.query(singularize(type) as keyof ModelRegistry, params);
  }

  setupController(
    controller: DataIndexListIndexController,
    model: DS.AdapterPopulatedRecordArray<AttributeModel | EventModel>,
    transition: Transition,
  ) {
    super.setupController(controller, model, transition);

    let { type } = this.paramsFor('data-index.type') as Record<string, any>;
    controller.set('type', singularize(type));

    let listController = this.controllerFor('data-index.type.list') as DataIndexListController;

    listController.setProperties({
      searchInput: controller.get('search'),
      paginationTotal: model.get('meta.pagination.total' as any),
      searchTotals: model.get('meta.totals' as any),
      items: model,
    });
  }

  @action
  reloadModel() {
    return this.refresh();
  }
}
